import { render, staticRenderFns } from "./saleableGoods.vue?vue&type=template&id=f82dd1c0&scoped=true"
import script from "./saleableGoods.vue?vue&type=script&lang=js"
export * from "./saleableGoods.vue?vue&type=script&lang=js"
import style0 from "./saleableGoods.vue?vue&type=style&index=0&id=f82dd1c0&prod&lang=stylus&scoped=true"
import style1 from "./saleableGoods.vue?vue&type=style&index=1&id=f82dd1c0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82dd1c0",
  null
  
)

export default component.exports